import type { ReactNode } from 'react';

import { usePermissions } from '@/hooks/usePermissions';

interface ProtectedComponentProps {
  children: ReactNode;
  requiredPermissions: string[];
  fallback?: ReactNode;
}

/**
 */
export function ProtectedComponent({
  children,
  requiredPermissions,
  fallback = null,
}: ProtectedComponentProps) {
  const { canAccessComponent } = usePermissions();

  const hasAccess = canAccessComponent({ requiredPermissions });

  if (!hasAccess) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
